/*
 * @Descripttion:
 * @Version: 1.0.0
 * @Author: 倪国晓
 * @Date: 2022-10-11 15:59:56
 * @LastEditors: 吴作杰 15727841808@163.com
 * @LastEditTime: 2023-12-14 11:44:02
 */
// 达人信息
export function DrInfo(h) {
	return h('div', [h('span', '达人信息')]);
}
// 团长信息
export function TzInfo(h) {
	return h('div', [h('span', '团长信息')]);
}

//达人联系人
export function DrContacts(h) {
	return h('div', [
		h('span', { style: { color: 'red' } }, '*'),
		h('span', '达人联系人'),
		h(
			'el-tooltip',
			{
				props: {
					effect: 'dark',
					content: '选择联系人后，本次操作将会同步到联系人选品小程序中',
					placement: 'top',
					openDelay: 300,
				},
			},
			[h('i', { class: 'iconfont ml-2 fz-14 yx-color-text-placeholder  icon-a-help-circlebangzhu-mian' })],
		),
	]);
}
